import cx from 'classnames';
import React from 'react';
import styles from './FlexTable.scss';

export const FlexTable: React.FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ children, className }) => (<div className={cx(styles.flexTable, className)}>{children}</div>);

interface FlexTableRowProps extends React.AllHTMLAttributes<HTMLDivElement> {
  isHeader?: boolean;
}

export const FlexTableRow: React.FC<FlexTableRowProps> = ({ children, className, isHeader }) => (
  <div
    className={cx(styles.flexTableRow, {
      [styles.flexTableRowHeading]: isHeader,
    }, className)}
  >
    {children}
  </div>
);

export const FlexTableCell: React.FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ children, className }) => (<div className={cx(styles.flexTableCell, className)}>{children}</div>);
